import GenericSearchBar from '../search/GenericSearchBar';
import { getCompanySuggestions } from '../../services/apiService';
import type { CompanySuggestion } from '../../types/api';

type Op = 'AND' | 'OR';

interface CompanySearchBarProps {
  onSearch?: (keywords: string[], ops: Op[]) => void;
  onClear?: () => void;
  initialValue?: string;
}

export default function CompanySearchBar({ onSearch, onClear, initialValue }: CompanySearchBarProps = {}) {
  return (
    <GenericSearchBar<CompanySuggestion>
      namespace="companies"
      destinationPath="/companies"
      detailPath={(s) => `/company/${s.id}`}
      suggestionsHeadingKey="command.companiesHeading"
      fetchSuggestions={getCompanySuggestions}
      renderSuggestionItem={(s, { highlight }) => (
        <span className="flex-1 truncate">{highlight(s.name)}</span>
      )}
      onSearch={onSearch}
      onClear={onClear}
      initialValue={initialValue}
    />
  );
}
